import { isPlatformBrowser } from '@angular/common'
import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID, ViewChild } from '@angular/core'
import { transformLoanAmountWithCommas } from 'src/app/core/helpers/fields-utils'
import { numberWithCommas } from 'src/app/core/helpers/inputs-helper'
import { ApiService } from 'src/app/core/services/api.service'
import { ChatState } from 'src/app/core/services/chat.service'
import { PageService } from 'src/app/core/services/page.service'
import { SESSION_TIMER_MINUTES } from '../options-utils/modal-shared'
import { SharedDataService } from '../../../../core/services/shared-data.service'

@Component({
    selector: 'app-modal-options-partial-approved',
    templateUrl: './modal-options-partial-approved.component.html',
    styleUrls: ['../modal-options.component.scss', './modal-options-partial-approved.component.scss'],
    standalone: false
})
export class ModalOptionsPartialApprovedComponent implements OnInit {

  constructor(
    public page: PageService,
    private cdr: ChangeDetectorRef,
    public sharedDataService: SharedDataService,
    @Inject(PLATFORM_ID) private platformId: object,
    ) { }

  @Input() approvedLoanAmount = '2,500'
  @Input() loanAmount = '2,500'
  @Input() responseData: any = null
  @Input() breakpoints: any = [{}]
  @Output() toggleLoader: EventEmitter<any> = new EventEmitter()
  @Output() showSelectEvent: EventEmitter<any> = new EventEmitter()

  transformLoanAmountWithCommas = transformLoanAmountWithCommas

  LA = '2500'

  /**
   * convert amount to number
   * @param amount - string appearance of amount
   * @returns Number(amount) or 0 if NaN
   */
  amountStringToNumber(amount: string): number{
    amount = amount + ''
    const newAmount = Number(amount.split(',').join('').split('$').join(''))
    if (isNaN(newAmount)) {
      return 0
    }
    return newAmount
  }

  /**
   * calc difference
   * @returns $ + (loanAmount - approvedLoanAmount)
   */
  calcDifference(): string {
    const loan = this.amountStringToNumber(this.loanAmount)
    const approved = this.amountStringToNumber(this.approvedLoanAmount)
    const res = loan - approved
    return '$' + this.transformLoanAmountWithCommas(res)
  }

  ngOnInit(): void {
    this.toggleLoader.emit(false)
    this.cdr.detectChanges()
    if (isPlatformBrowser(this.platformId)) {
    }
  }


  goToSelectLoan() {
    this.showSelectEvent.emit()
  }


}
